import { Component, EventEmitter, inject, Input, OnInit, Optional, Output } from '@angular/core'
import { ControlContainer, FormsModule, NgForm } from '@angular/forms'

import { PrimeTemplate } from 'primeng/api'
import { AutoComplete } from 'primeng/autocomplete'

import { Landlord } from '@app/interfaces/landlord'
import { LandlordsApi } from '@app/apis/landlords.api'
import { DetailMode } from '@app/components/generic/generic.constants'
import { RequiredFieldTextComponent } from '@app/components/metadata/required-field-text.component'
import type { Landlord as LandlordListItem } from '@app/generated/api/model'

@Component({
  selector: 'app-landlord-field',
  templateUrl: 'landlord-field.component.html',
  viewProviders: [{
    provide: ControlContainer,
    deps: [[Optional, NgForm]],
    useFactory: (ngForm: NgForm) => ngForm,
  }],
  imports: [
    AutoComplete,
    FormsModule,
    PrimeTemplate,
    RequiredFieldTextComponent,
  ],
})
export class LandlordFieldComponent implements OnInit {
  public readonly landlordsApi = inject(LandlordsApi)

  @Input() landlord?: Landlord
  @Input() required: boolean = false
  @Input() recommended: boolean = false
  @Input() mode: string = 'normal'
  @Input() tabindex: number = -1

  @Output() landlordChange = new EventEmitter<Landlord | undefined>()

  public allLandlords: LandlordListItem[] = []
  protected readonly DetailMode = DetailMode

  ngOnInit (): void {
    this.allLandlords = []
  }

  getLandlordSuggestions ($event: { query: string, originalEvent: any }) {
    const params = { limit: 100, ordering: 'code', code: $event.query }
    this.landlordsApi.list(params).subscribe(response => {
      this.allLandlords = response.results
    })
  }
}
